(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var mapFormToObject = require('cf-map-form-to-object')
  , moment = require('moment')

module.exports = function customMapFormToObject (form, schema) {
  var data = mapFormToObject(form, schema)

  Object.keys(schema).forEach(function (key) {
    // only override dates with UTC dates
    if (schema[key].type === Date) {
      var value = getDateValue(form, key)
      if (value) {
        data[key] = getUTCCastedDate(value)
      }
    }
  })

  return data
}

function getDateValue (form, key) {
  var val = form.find(':input[name=' + key + ']').val()
  return val || null
}

function getUTCCastedDate (date) {
  return moment.utc(date).toDate()
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/map-form-to-object-utc-dates.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL21hcC1mb3JtLXRvLW9iamVjdC11dGMtZGF0ZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJ2YXIgbWFwRm9ybVRvT2JqZWN0ID0gcmVxdWlyZSgnY2YtbWFwLWZvcm0tdG8tb2JqZWN0JylcbiAgLCBtb21lbnQgPSByZXF1aXJlKCdtb21lbnQnKVxuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uIGN1c3RvbU1hcEZvcm1Ub09iamVjdCAoZm9ybSwgc2NoZW1hKSB7XG4gIHZhciBkYXRhID0gbWFwRm9ybVRvT2JqZWN0KGZvcm0sIHNjaGVtYSlcblxuICBPYmplY3Qua2V5cyhzY2hlbWEpLmZvckVhY2goZnVuY3Rpb24gKGtleSkge1xuICAgIC8vIG9ubHkgb3ZlcnJpZGUgZGF0ZXMgd2l0aCBVVEMgZGF0ZXNcbiAgICBpZiAoc2NoZW1hW2tleV0udHlwZSA9PT0gRGF0ZSkge1xuICAgICAgdmFyIHZhbHVlID0gZ2V0RGF0ZVZhbHVlKGZvcm0sIGtleSlcbiAgICAgIGlmICh2YWx1ZSkge1xuICAgICAgICBkYXRhW2tleV0gPSBnZXRVVENDYXN0ZWREYXRlKHZhbHVlKVxuICAgICAgfVxuICAgIH1cbiAgfSlcblxuICByZXR1cm4gZGF0YVxufVxuXG5mdW5jdGlvbiBnZXREYXRlVmFsdWUgKGZvcm0sIGtleSkge1xuICB2YXIgdmFsID0gZm9ybS5maW5kKCc6aW5wdXRbbmFtZT0nICsga2V5ICsgJ10nKS52YWwoKVxuICByZXR1cm4gdmFsIHx8IG51bGxcbn1cblxuZnVuY3Rpb24gZ2V0VVRDQ2FzdGVkRGF0ZSAoZGF0ZSkge1xuICByZXR1cm4gbW9tZW50LnV0YyhkYXRlKS50b0RhdGUoKVxufVxuIl19